<section class="container-fluid hero">
  <app-header></app-header>
  <div class="container">
    <div class="row py-5">
      <div class="col-lg-12">
        <h1 class="mb-2">All Tools</h1>

        <p class="header-p mx-auto" style="max-width: 620px;">
          AI-Powered Writing Excellence: Tailored Solutions for Every Need with Responsible Machine Learning.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="academic-writing">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 mb-2 mt-4">
        <h2 class="mb-2 text-center">All Tools for Students and Academic Writing</h2>

        <p class="text-center">
          Elevate your academic writing with AI tools for research, essays,
          assignments, and study assistance.
        </p>
      </div>


      <div *ngFor="let tool of tools3" class="col-lg-4 col-md-6 col-12  mb-md-4 mb-3">
        <a [routerLink]="[tool.link]" *ngIf="tool.link">
          <div class="cards">
            <div class="img-pen">
              <app-icons-free-tools [name]="tool.icon" />
              <div class="textdata">
                <span [innerHTML]="tool.title" class="title"></span>
                <span [innerHTML]="tool.description" class="description"></span>
              </div>
            </div>

            <div class=" rightarrow  ">
              <app-icons-free-tools name="allToolsTick" />
            </div>
          </div>
        </a>
        <div *ngIf="!tool.link" class="cards">
          <div class="img-pen">
            <app-icons-free-tools [name]="tool.icon" />
            <div class="textdata">
              <span [innerHTML]="tool.title" class="title"></span>
              <span [innerHTML]="tool.description" class="description"></span>
            </div>
          </div>

          <div class=" rightarrow  ">
            <app-icons-free-tools name="allToolsTick" />
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="writing-assistance">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 mb-2">
        <h2 class="mb-2 text-center">AI Tools for General Writing Assistance</h2>

        <p class="text-center">
          Discover top AI tools for writing that help you craft compelling
          content quickly and efficiently.
        </p>
      </div>

      <div class="col-lg-4 col-md-6 col-12  mb-md-4 mb-3" *ngFor="let tool of tools4">
        <a [routerLink]="[tool.link]">
          <div class="cards">
            <div class="img-pen">
              <app-icons-free-tools [name]="tool.icon" />
              <div class="textdata">
                <span [innerHTML]="tool.title" class="title"></span>
                <span [innerHTML]="tool.description" class="description"></span>
              </div>
            </div>

            <div class=" rightarrow  ">
              <app-icons-free-tools name="allToolsTick" />
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="career-advancement">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 mb-2">
        <h2 class="mb-2 text-center">AI Tools for Job Search and Career Advancement</h2>

        <p class="text-center">
          Unlock powerful AI tools to boost your job search, resume building,
          and career development strategies.
        </p>
      </div>

      <div *ngFor="let tool of tools2" class="col-lg-4 col-md-6 col-12  mb-md-4 mb-3">
        <a [routerLink]="[tool.link]">
          <div class="cards">
            <div class="img-pen">
              <app-icons-free-tools [name]="tool.icon" />
              <div class="textdata">
                <span [innerHTML]="tool.title" class="title"></span>
                <span [innerHTML]="tool.description" class="description"></span>
              </div>
            </div>

            <div class=" rightarrow  ">
              <app-icons-free-tools name="allToolsTick" />
            </div>
          </div>
        </a>
      </div>

    </div>
  </div>
</section>

<section class="work-busniess">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 mb-2">
        <h2 class="mb-2 text-center">
          AI Writing Tools for Professional Work and Business
        </h2>

        <p class="text-center">
          Streamline your workplace writing with advanced AI tools designed for
          business, reports, emails, and more.
        </p>
      </div>

      <div *ngFor="let tool of tools1" class="col-lg-4 col-md-6 col-12  mb-md-4 mb-3">
        <a [routerLink]="[tool.link]">
          <div class="cards">
            <div class="img-pen">
              <app-icons-free-tools [name]="tool.icon" />
              <div class="textdata">
                <span [innerHTML]="tool.title" class="title"></span>
                <span [innerHTML]="tool.description" class="description"></span>
              </div>
            </div>

            <div class=" rightarrow  ">
              <app-icons-free-tools name="allToolsTick" />
            </div>
          </div>
        </a>
      </div>


    </div>
  </div>
</section>

<section class="content-creation">
  <div class="container">
    <div class="row pt-5 mb-5">
      <div class="col-lg-12 mb-2">
        <h2 class="mb-2 text-center">AI Writing Tools for Content Creation</h2>

        <p class="text-center">
          Enhance your content creation process with the best AI writing tools
          for blogs, articles, and more.
        </p>
      </div>

      <div *ngFor="let tool of tools" class="col-lg-4 col-md-6 col-12  mb-md-4 mb-3">
        <a [routerLink]="[tool.link]" target="_blank" rel="noopener noreferrer">
          <div class="cards">
            <div class="img-pen">
              <app-icons-free-tools [name]="tool.icon" />
              <div class="textdata">
                <span [innerHTML]="tool.title" class="title"></span>
                <span [innerHTML]="tool.description" class="description"></span>
              </div>
            </div>

            <div class=" rightarrow  ">
              <app-icons-free-tools name="allToolsTick" />
            </div>
          </div>
        </a>
      </div>

    </div>
  </div>
</section>

<app-footer></app-footer>